import { createFileRoute } from '@tanstack/react-router';

import { EventEnrollmentsPage } from '~features/events/ui/event-enrollments';

const Component = () => {
  const { eventId } = Route.useParams();
  return <EventEnrollmentsPage eventId={eventId} />;
};

export const Route = createFileRoute(
  '/_auth/_layout/events/$eventId/enrolled-students',
)({
  component: Component,
});
